import React from "react";
import { Card, Table, Badge, Button, Alert } from "react-bootstrap";
import useSWR, { mutate } from "swr";
import { serverUrl, fetcher, swrConfig } from "../../../../helpers/utility";
import Loading from "../../../../components/loading";
import { format, isBefore, isToday } from "date-fns";
import axios from "axios";

function InvitesList({ user }) {
  const { data, error, isLoading } = useSWR(
    `${serverUrl}/provider/invites`,
    fetcher,
    swrConfig
  );

  const handleCancelInvite = async (inviteId) => {
    if (window.confirm("Are you sure you want to cancel this invite?")) {
      try {
        const response = await axios.delete(`${serverUrl}/invite/${inviteId}`);
        if (response.data?.success) {
          mutate(`${serverUrl}/provider/invites`); // Refresh the list
        } else {
          alert(response.data?.message || "Failed to cancel invite.");
        }
      } catch (err) {
        console.error("Error cancelling invite:", err);
        alert(err.response?.data?.message || "Failed to cancel invite. Please try again.");
      }
    }
  };

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return (
      <Card>
        <Card.Body>
          <p className="text-danger">Error loading invites. Please try again.</p>
        </Card.Body>
      </Card>
    );
  }

  const invites = data?.invites || [];

  const getStatusBadge = (invite) => {
    if (invite.status === "ACCEPTED") {
      return <Badge bg="success">Accepted</Badge>;
    }
    if (invite.status === "CANCELLED") {
      return <Badge bg="danger">Cancelled</Badge>;
    }
    if (invite.status === "PENDING" && invite.expiresAt && isBefore(new Date(invite.expiresAt), new Date())) {
      return <Badge bg="warning">Expired</Badge>;
    }
    return <Badge bg="info">Pending</Badge>;
  };

  return (
    <Card>
      <Card.Header>
        <h5 className="mb-0">Pending Invites ({invites.filter(i => i.status === "PENDING").length})</h5>
      </Card.Header>
      <Card.Body>
        {invites.length === 0 ? (
          <p className="text-muted">No invites sent yet.</p>
        ) : (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Email</th>
                <th>Role</th>
                <th>Status</th>
                <th>Invited On</th>
                <th>Expires</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {invites.map((invite) => (
                <tr key={invite._id}>
                  <td>{invite.email}</td>
                  <td><Badge bg="secondary">{invite.role}</Badge></td>
                  <td>{getStatusBadge(invite)}</td>
                  <td>
                    {invite.created
                      ? format(new Date(invite.created), "dd/MM/yyyy")
                      : "—"}
                  </td>
                  <td>
                    {invite.expiresAt && isBefore(new Date(invite.expiresAt), new Date())
                      ? "Expired"
                      : invite.expiresAt
                      ? format(new Date(invite.expiresAt), "dd/MM/yyyy")
                      : "—"}
                  </td>
                  <td>
                    {invite.status === "PENDING" && (
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => handleCancelInvite(invite._id)}
                      >
                        Cancel
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
}

export default InvitesList;

